<div id="mainWrapper" class="container" [ngClass]="{'catalogue-details catalogue-details--services':(isStorePage==true)}">
    <app-header
      [user]="user"
      [notifications]="notifications"
      [unreadNotificationsCount]="unreadNotificationsCount"
      (viewNotification)="viewNotification($event)"
    ></app-header>

    <section id="content-wrapper"  [ngClass]="{'upInvoice': (isInvoiceListing == true), 'paymentPage': (isPaymentPage == true), 'upInvoice quotation-reciever-view quotation-reciever-view--shadow': (isQuatationListing == true)}">
      <main id="site-main" [ngClass]="{'white-bg': (addBgWhiteClass == true), 'dashboard': (isInvoiceListing == false && isCreateInvoice == false), 'invoces_page': (isInvoiceListing == true), 'create_invoces_page': (isCreateInvoice == true)}" [ngStyle]="addNormalPaddingStyle ? {'padding': '40px 64px'} : {}">
      	<upgrade-baner
          [user]="user"
          [notifications]="notifications"
          [unreadNotificationsCount]="unreadNotificationsCount"
          (viewNotification)="viewNotification($event)"
        ></upgrade-baner>
        <div class="wrap overflow-visible" >
          <router-outlet></router-outlet>
        </div>

      </main>
    </section>
    <!-- end content-wrapper -->
</div>
